module.exports = __webpack_public_path__ + "static/media/kingLogoDark.70ebacf7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/kingLogoDark.svg
// module id = 50
// module chunks = 0